module.exports = __webpack_public_path__ + "static/media/edit-pencil-white.8b6de730.svg";